import {
  Switch,
  Route,
  useLocation,
  useHistory
} from "react-router-dom";

import {
  Home} from "src/pages";
import { SignoutPage } from "./pages/Signout";
import { path$ } from "./framework/store/AppStore";

type ApplicationPathType = {
  path: string;
  params: string[];
  page: any;
}

type PathObjectType = { [key: string]: ApplicationPathType }

const PATHS: PathObjectType = {
  "home": {
    path: "/",
    params: [":params?"],
    page: Home
  },
  "signout": {
    path: "/signout",
    page: SignoutPage,
    params: [":params?"],
  }
}


export default function Routes() {
  const location = useLocation();
  const history = useHistory();

  const getPaths = () => {
    const keys = Object.keys(PATHS);
    const _paths: string[] = [];

    for (let key of keys) {
      _paths.push(PATHS[key].path);
    }

    return _paths;
  }

  if (!getPaths().includes(location.pathname)) {
    path$.next(location as any)
    history.push(PATHS.not_found?.path || "/");
  }

  return (
    <Switch>
      <Route exact path={PATHS.signout.path} component={PATHS.signout.page} />
      <Route exact path={PATHS.home.path} component={PATHS.home.page} />
    </Switch>
  );
}
